<mat-form-field>
  <mat-label>Tag Types</mat-label>
  <mat-select
    [formControl]="formControl"
    [multiple]="multiple"
    #selectionList
    (selectionChange)="selectionChanged($event)"
  >
    @for (tagType of availableTagTypes; track tagType.tagTypeId) {
      <mat-option [value]="tagType">{{ tagType.displayName }}</mat-option>
    }
  </mat-select>
  @if (formControl.errors?.["required"]) {
    <mat-error>Please choose a tag type</mat-error>
  }
</mat-form-field>
